import { logger } from '@fiverr-private/obs';
import { MODULE_NAME } from '../constants';

export const logError = ({ message, details }: { message: string; details?: unknown }): void => {
    logger.error(`[${MODULE_NAME}] ${message}`, { details });
};
